export default "__VITE_ASSET__CrI6fD9b__"